<template>
  <div class="it_hardware_wrap">
    <div class="it_hardware_img">
      <div class="production_img_inner">
<!--        <div class="img_desc">良悦企业资源计划管理系统解决方案</div>-->
        <div class="img_tit">企业园区建设服务商</div>
                <div class="img_desc">智造产业生态，赋能未来增长--为企业发展打下坚实基础</div>
        <router-link class="img_btn" to="/Experience">立即咨询</router-link>
      </div>

    </div>
<!--    <div class="tab-area hidden-xs-only">-->
<!--      <div class="tab-area-bg"></div>-->
<!--      <el-tabs v-model="activeName" @tab-click="handleClick" class="tabs">-->
<!--        <el-tab-pane label="服务定位" name="first"></el-tab-pane>-->
<!--        <el-tab-pane label="IT建设方案" name="second"></el-tab-pane>-->
<!--        <el-tab-pane label="产品与设备" name="third"></el-tab-pane>-->
<!--        <el-tab-pane label="合作伙伴" name="fourth"></el-tab-pane>-->
<!--      </el-tabs>-->
<!--    </div>-->
    <div class="service-card" >
      <div class="it_hardware_inner">
        <div class="inner_center">
          <div class="it_hardware_title">服务定位</div>
          <div class="it_hardware_desc" style="text-align: center">通过科技融合+全周期合作，助力企业打造智能、安全、可持续的数字化园区，提升竞争力与生命力。</div>
        </div>
      </div>
      <div class="it_hardware_box hidden-sm-and-up" >
        <div class="it_hardware_item">
          <div class="title">
            <img  src="../../assets/img/solution/kcjzh.png"/>
            <div>核心定位 </div>
            <div class="content">目标：赋能企业空间数字化转型，构建安全、高效、体验优、面向未来的智能园区。</div>
              <div class="content">手段：通过前沿科技（如物联网、AI）的整体规划与深度融合。</div>
          </div>
        </div>
        <div class="it_hardware_item">
          <div class="title">
            <img  src="../../assets/img/solution/zlxt.png"/>
            <div>合作伙伴价值</div>
            <div class="content">贯穿全程的协作模式，从规划到运营的全周期合作，覆盖技术整合（如云计算、数字孪生）、流程优化（如自动化管理）</div>
          </div>
        </div>
        <div class="it_hardware_item">
          <div class="title">
            <img  src="../../assets/img/park-construction/jszc.jpg"/>
            <div>技术支撑</div>
            <div class="content">安全可控：数据加密、系统稳定性。</div>
            <div class="content">高效协同：生态合作资源共享。</div>
<!--            <div class="content">体验卓越：个性化服务（智能交通、环境调节）</div>-->
          </div>
        </div>
        <div class="it_hardware_item">
          <div class="title">
            <img  src="../../assets/img/solution/lcyh.png"/>
            <div>战略闭环</div>
            <div class="content">需求：响应企业数字化刚性需求(政策/竞争驱动)。</div>
              <div class="content">方案：提供技术+管理整体解决方案。</div>
              <div class="content">结果：实现组织敏捷性(快速响应)与可持续性(绿色低碳)</div>
          </div>
        </div>
      </div>
      <div class="it_hardware_box dingwei-bg hidden-xs-only">
        <div class="it_hardware_item">
          <img src="../../assets/img/park-construction/DW_hxdw.jpg" />
          <div class="title">核心定位
            <div class="content">目标：赋能企业空间数字化转型，构建安全、高效、体验优、面向未来的智能园区。</div>
              <div class="content second-content"> 手段：通过前沿科技（如物联网、AI）的整体规划与深度融合。</div>
          </div>
        </div>
        <div class="it_hardware_item">
          <img src="../../assets/img/park-construction/DW_hzhb.jpg" />
          <div class="title">合作伙伴价值
            <div class="content">贯穿全程的协作模式，从规划到运营的全周期合作，覆盖技术整合（如云计算、数字孪生）、流程优化（如自动化管理）</div>
          </div>
        </div>
        <div class="it_hardware_item">
          <img src="../../assets/img/park-construction/DW_jszc.jpg" />
          <div class="title">技术支撑
            <div class="content">安全可控：数据加密、系统稳定性。</div>
            <div class="content second-content"> 高效协同：生态合作资源共享。</div>
<!--            <div class="content second-content"> 体验卓越：个性化服务（智能交通、环境调节）</div>-->
          </div>
        </div>
        <div class="it_hardware_item">
          <img src="../../assets/img/park-construction/DW_zlbh.jpg" />
          <div class="title">战略闭环
            <div class="content">需求：响应企业数字化刚性需求（政策/竞争驱动）。</div>
            <div class="content second-content">方案：提供技术+管理整体解决方案。</div>
            <div class="content second-content">结果：实现组织敏捷性（快速响应）与可持续性（绿色低碳）</div>
          </div>
        </div>
      </div>
    </div>
    <div class="tedian dingwei-bottom" >
        <div class="it_hardware_inner hidden-xs-only">
          <div class="inner_center" >
            <div class="it_hardware_title">致力于赋能企业空间的数字化转型</div>
            <div class="it_hardware_desc">通过前沿科技的整体规划与深度融合，构建安全可控、高效协同、</div>
            <div class="it_hardware_desc">面向未来的智能园区环境</div>
          </div>
        </div>
        <div class="it_hardware_inner hidden-sm-and-up" style="padding-top: 0">
          <div class="inner_center" >
            <div class="it_hardware_title">致力于赋能企业空间的数字化转型</div>
            <div class="it_hardware_desc">通过前沿科技的整体规划与深度融合，构建安全可控、高效协同、面向未来的智能园区环境</div>
          </div>
        </div>
    </div>
    <div class="center-area " >
      <div class="it_hardware_inner">
        <div class="inner_center">
          <div class="it_hardware_title">综合安防建设方案</div>
        </div>
      </div>
      <div class="tab-content" style="margin-bottom: 0">
        <el-radio-group v-model="tabRadio" class="hidden-xs-only">
          <el-radio-button label="1">视频监控系统建设</el-radio-button>
          <el-radio-button label="2">停车管理系统建设</el-radio-button>
          <el-radio-button label="3">园区报警系统建设</el-radio-button>
          <el-radio-button label="4">门禁管理系统建设</el-radio-button>
          <el-radio-button label="5">园区对讲广播建设</el-radio-button>
        </el-radio-group>
        <el-radio-group v-model="tabRadio" class="hidden-sm-and-up">
          <el-radio-button label="1">视频监控系统建设</el-radio-button>
          <el-radio-button label="2">停车管理系统建设</el-radio-button>
          <el-radio-button label="3">园区报警系统建设</el-radio-button>
        </el-radio-group>
        <el-radio-group v-model="tabRadio" class="hidden-sm-and-up">
          <el-radio-button label="4">门禁管理系统建设</el-radio-button>
          <el-radio-button label="5">园区对讲广播建设</el-radio-button>
        </el-radio-group>
      </div>
      <div class="row-div">
        <el-row>
          <el-col :span="24" class="hidden-sm-and-up" v-if="tabRadio==='1'"><div class="hx-img height3" style="text-align: center"><img src="../../assets/img/park-construction/zhaf_01.jpg" /></div></el-col>
          <el-col :span="12" :xs="24" class="hx-text height3" v-if="tabRadio==='1'">
<!--            <div class="title-sub1">构建敏捷、弹性、安全的数字化底座</div>-->
<!--            <div class="title-sub2">虚拟化平台建设是当代企业IT架构转型的核心策略，其优势与价值不仅体现在资源优化和成本节约上，更在业务连续性、管理效率和安全性等方面带来变革性提升。</div>-->
            <div class="hx-content hx-content-height1">
              <div class="line"></div>
              <div class="title-sy">全域无死角监控</div>
              <div class="desc">创新融合多光谱成像与智能布点算法，实现园区室内外立体化覆盖。高空鹰眼联动地面云台，复杂地形与夜间场景精准可视，无人机灵活补位，确保周界、通道、盲区全天候守护。</div>
            </div>
            <div class="hx-content">
              <div class="line"></div>
              <div class="title-sy">AI主动预警体系</div>
              <div class="desc">内嵌深度学习行为分析引擎，智能识别人员闯入、违规操作、设备异常等风险。声光告警联动指挥中心，实现“监测-预警-干预”自动化闭环，变被动监控为主动防御。</div>
            </div>
            <div class="hx-content">
              <div class="line"></div>
              <div class="title-sy">专用监控传输网络</div>
              <div class="desc">独立构建光纤环网架构，与办公网络物理隔离。多重冗余设计保障高可靠传输，流量智能调度优化带宽分配，抗干扰抗攻击，确保视频流稳定无延时。</div>
            </div>
            <div class="hx-content">
              <div class="line"></div>
              <div class="title-sy">全生命周期设备管理</div>
              <div class="desc">智能运维平台实时诊断设备健康状态，自愈机制快速定位故障。远程配置升级与能耗动态优化，延长设备服役周期，降低运维复杂度，实现资产高效管理。</div>
            </div>
            <el-button type="primary" round class="hx-btn" @click="toZixun">了解视频监控方案</el-button>
          </el-col>
          <el-col :span="12" class="hidden-xs-only" v-if="tabRadio==='1'"><div class="hx-img height3" style="text-align: right"><img src="../../assets/img/park-construction/zhaf_01.jpg" /></div></el-col>
          <el-col :span="12" :xs="24"  v-if="tabRadio==='2'"><div class="hx-img height3"><img src="../../assets/img/park-construction/zhaf_02.jpg" /></div></el-col>
          <el-col :span="12" :xs="24" v-if="tabRadio==='2'"><div class="hx-text height3">
<!--            <div class="title-sub1">以软件为中心，替代传统架构</div>-->
<!--            <div class="title-sub2">超融合平台（Hyper-Converged Infrastructure, HCI）通过整合计算、存储、网络等资源，以软件定义方式实现统一管理，为企业数字化转型提供了高效、灵活的IT基础架构。 </div>-->
            <div class="hx-content">
              <div class="line"></div>
              <div class="title-sy">车辆管理与引导，提升出入效率</div>
              <div class="desc">智能车牌识别实现无感通行；场内传感器实时监测车位，多级引导屏动态指引。大幅减少寻位时间，显著提升高峰时段通行效率，优化用户体验。</div>
            </div>
            <div class="hx-content hx-content-height1">
              <div class="line"></div>
              <div class="title-sy">数据分析统计与报表支持</div>
              <div class="desc">自动汇聚车辆流量、高峰时段等多维度数据；生成可视化报表，提供实时运营洞察。辅助管理者分析历史规律，优化园区资源配置与分区管理策略。</div>
            </div>
            <div class="hx-content hx-content-height1">
              <div class="line"></div>
              <div class="title-sy">全生命周期设备管理</div>
              <div class="desc">支持设备维护与故障告警，实时监控道闸、摄像头等关键设备状态与性能；异常故障自动分级告警并精准定位。支持建立维护档案与计划，实现巡检维修数字化管理，保障系统可靠运行。</div>
            </div>
            <div class="hx-content hx-content-height1">
              <div class="line"></div>
              <div class="title-sy">集成扩展能力</div>
              <div class="desc">提供API接口，灵活对接企业SCM等系统，实现数据互通与业务协同。预留强大扩展性，支持平滑接入新技术与新应用，适应未来业务发展。</div>
            </div>
            <el-button type="primary" round class="hx-btn" @click="toZixun">了解停车管理方案</el-button>
          </div>
          </el-col>
          <el-col :span="24" class="hidden-sm-and-up" v-if="tabRadio==='3'"><div class="hx-img height6"><img src="../../assets/img/park-construction/zhaf_03.jpg" /></div></el-col>
          <el-col :span="12" :xs="24" v-if="tabRadio==='3'">
            <div class="hx-text height6">
<!--              <div class="title-sub1">多维度保障业务韧性</div>-->
<!--              <div class="title-sub2">业务容灾解决方案是企业应对自然灾害、硬件故障、网络攻击等突发灾难的核心防御体系，其核心价值在于保障业务连续性、最小化数据丢失、优化成本结构并支撑战略转型。</div>-->
              <div class="hx-content">
                <div class="line"></div>
                <div class="title-sy">高效应急联动机制</div>
                <div class="desc">实现秒级响应的全方位协同，自动联动监控系统、开启逃生通道并实时推送警情。预设多类突发事件预案，支持多部门一键调度联动，有效防止事态升级。</div>
              </div>
              <div class="hx-content">
                <div class="line"></div>
                <div class="title-sy">数据分析与预防性安防</div>
                <div class="desc">智能分析引擎通过热力图动态锁定高频风险区域（如易突破围墙段），实时加强布防；基于设备传感器数据预判故障风险（如摄像头遮挡、线路老化），自动触发预维护机制。双维预警体系将被动响应转变为空间与设备的主动防护闭环。</div>
              </div>
              <div class="hx-content">
                <div class="line"></div>
                <div class="title-sy">成本优化能力</div>
                <div class="desc">深度兼容既有监控、门禁等系统，保护旧设备投资。创新架构实现新旧设备资源智能复用，同步降低新增硬件投入与运维复杂度，构建平滑升级的全周期成本控制体系。</div>
              </div>
              <el-button type="primary" round class="hx-btn" @click="toZixun">了解园区报警方案</el-button>
            </div>
          </el-col>
          <el-col :span="12" class="hidden-xs-only" v-if="tabRadio==='3'"><div class="hx-img height6" style="text-align: right"><img src="../../assets/img/park-construction/zhaf_03.jpg" /></div></el-col>
          <el-col :span="12" :xs="24"  v-if="tabRadio==='4'"><div class="hx-img height7"><img src="../../assets/img/park-construction/zhaf_04.jpg" /></div></el-col>
          <el-col :span="12" :xs="24" v-if="tabRadio==='4'">
            <div class="hx-text height7" >
<!--            <div class="title-sub1">构筑高效可靠的企业数字动脉</div>-->
<!--            <div class="title-sub2">业务连续性始于稳固的网络根基。我们专注为企业打造高性能、高可用的网络基础设施，通过精准架构设计与前沿技术部署，构建覆盖全场景的数据传输通道。全面支撑企业办公、生产、云端协作等核心业务需求，让数据流转如血脉般顺畅有力，为您的数字化进程铺设坚实跑道。</div>-->
            <div class="hx-content">
              <div class="line"></div>
              <div class="title-sy">自主掌控数据，筑牢安全防线</div>
              <div class="desc">采用本地私有服务器部署模式，所有用户数据（包括生物特征模板、权限配置、出入记录）均存储于企业自建机房或指定数据中心，隔离云端传输风险。支持HTTPS加密通信与数据库加密存储，确保数据全生命周期安全。管理员可通过B/S架构的Web管理平台集中管控权限，实现“数据不出内网，管理不离掌控”。</div>
            </div>
            <div class="hx-content hx-content-height1">
              <div class="line"></div>
              <div class="title-sy">人脸·指纹·刷卡，安全无死角</div>
              <div class="desc">终端设备集成人脸识别、活体指纹验证、IC卡三种认证方式，可根据安全等级动态组合验证策略。高危区域（如机房、实验室）支持强制启用“人脸+刷卡”或“指纹+人脸”双因子认证，普通办公区支持单模式便捷通行，兼顾安全与效率。</div>
            </div>
            <div class="hx-content hx-content-height1">
              <div class="line"></div>
              <div class="title-sy">精准记录·自动统计·人力减负</div>
              <div class="desc">门禁通行记录自动同步至考勤系统，员工刷脸/刷卡进门即完成打卡。系统自动生成出勤报表（含迟到、早退、缺勤明细），支持按部门/个人导出，支持对接企业OA或HR系统，消除人工登记误差，降低考勤管理成本。</div>
            </div>
            <el-button type="primary" round class="hx-btn" @click="toZixun">了解门禁管理方案</el-button>
          </div>
          </el-col>
          <el-col :span="24" class="hidden-sm-and-up" v-if="tabRadio==='5'"><div class="hx-img height4" style="text-align: right"><img src="../../assets/img/park-construction/zhaf_05.jpg" /></div></el-col>
          <el-col :span="12" :xs="24" v-if="tabRadio==='5'">
            <div class="hx-text height4">
<!--              <div class="title-sub1">重塑企业移动生产力</div>-->
<!--              <div class="title-sub2">从移动办公到智能制造，稳定高速的无线连接已成为企业竞争力的核心要素。</div>-->
              <div class="hx-content">
                <div class="line"></div>
                <div class="title-sy">企业网络高效复用</div>
                <div class="desc">基于IP网络架构复用企业现有有线/WiFi基础设施，支持跨网段、跨路由灵活接入。通过智能网络穿透技术实现低延迟通信，结合动态带宽优化保障生产业务稳定运行。系统兼容传统模拟设备，降低改造成本，与视频会议、能耗管理等系统共享网络资源，实现多基地高效协同，大幅减少运维投入。</div>
              </div>
              <div class="hx-content">
                <div class="line"></div>
                <div class="title-sy">智能声控融合与系统集成</div>
                <div class="desc">提供点对点对讲、多级群组通话及精准分区广播能力，AI语音识别与文本转语音技术实现指令自动播报。开放API深度集成MES、消防、门禁等系统，触发多场景智能联动：消防报警自动切换应急广播并播报疏散指令；监控异常行为即时联动语音威慑；设备故障自动推送维修指令至工程师终端。</div>
              </div>
              <div class="hx-content">
                <div class="line"></div>
                <div class="title-sy">多场景终端覆盖与工业级适配方案</div>
                <div class="desc">针对复杂工业环境部署多品类专业终端：高抗噪号角攻克强噪车间环境；防水音柱适应户外极端天气；防爆对讲终端保障危险区域安全通信；可视终端实现人脸识别与远程管控；吸顶喇叭支持办公区背景音乐；太阳能设备满足无电区长续航需求。</div>
              </div>
              <el-button type="primary" round class="hx-btn" @click="toZixun">了解园区对讲广播方案</el-button>
            </div>
          </el-col>
          <el-col :span="12" class="hidden-xs-only" v-if="tabRadio==='5'"><div class="hx-img height5" style="text-align: right"><img src="../../assets/img/park-construction/zhaf_05.jpg" /></div></el-col>
        </el-row>
      </div>

    </div>
    <div class="tedian1 padding80" >
      <Zixun :zixun = "centerDialogVisible"/>
    </div>
    <CallMe />
    <MobileCallme />
  </div>
</template>

<script>
// import ProCard from './ProCard.vue'
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'
import Zixun from "@/components/zixun/index.vue";
export default {
  data() {
    return {
      activeName:"first",
      centerDialogVisible: false,
      tabRadio: '1',
      cardList: [
        {
          src: require('@/assets/img/solution/hexin1.png'),
          title: '生产管理',
          desc1: '支持离散制造与流程制造模式，灵活应对定制化需求，生产进度实时监控、设备维护计划及工时成本核算',
        },
        {
          src: require('@/assets/img/solution/hexin2.png'),
          title: '质量管理',
          desc1: '全流程质检、质量追溯与改进建议生成',
        },
        {
          src: require('@/assets/img/solution/hexin3.png'),
          title: '财务管理',
          desc1: '成本核算（直接/间接成本）、预算控制、多维财务报表生成',
        },
        {
          src: require('@/assets/img/solution/hexin4.png'),
          title: '物料管理',
          desc1: '动态库存预警、BOM（物料清单）管理、采购与领料自动化',
        },
        {
          src: require('@/assets/img/solution/hexin5.png'),
          title: '供应链协同',
          desc1: '供应商分级评估、采购成本分析、物流状态可视化',
        },
        {
          src: require('@/assets/img/solution/hexin6.png'),
          title: '移动化支持',
          desc1: '手机/PDA终端实现工序汇报、库存查询、审批流程移动化',
        },
      ],
      currentSub:""
    }
  },
  components: {
    Zixun,
    CallMe,
    MobileCallme,
  },
  methods:{
    toZixun() {
      this.centerDialogVisible = false;
      this.$nextTick(() => {
        this.centerDialogVisible = true;
      });

    },
    overSub(flag){
      this.currentSub = flag
    },
    outSub(){
      this.currentSub = ''
    },
    handleClick(){
      if(this.activeName==="first"){
        const element = document.getElementById('cpjz');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'start'});
        }
      }
      if(this.activeName==="second"){
        const element = document.getElementById('jsfa');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'start'});
        }
      }
      if(this.activeName==="third"){
        const element = document.getElementById('fwfc');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'start'});
        }
      }
      if(this.activeName==="fourth"){
        const element = document.getElementById('gzfx');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' ,block: 'start'});
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.tedian1 {
  background-color: #F5F7FA;
  padding: 5px 0 5px 0;
  margin-top: -5px;
}
.tedian{
  background-color:#ffffff;
  padding: 5px 0 5px 0 ;
  @media screen and (max-width: 768px) {
    //padding-bottom: 10PX;
  }
  .title_card{
    width: 80%;
    margin: 40px auto 0 auto;
    @media screen and (max-width: 768px) {
      width: 95%;
      //overflow-x: auto;
      padding-bottom: 5px;
    }
    img{
      width: 100%;
      margin-bottom: 0;
      @media screen and (max-width: 768px) {
        width: 100%;
      }
    }
  }
  .it_hardware_card{
    margin-top: 20px !important;
  }

}
.it_hardware_wrap {
  width: 100%;
  margin-top: 70px;
  @media screen and (max-width: 768px) {
    background-color: #f8fafd;
  }
  .it_hardware_inner{
    @media screen and (max-width: 768px) {
      padding: 20PX 0 0 0;
    }
  }
  .it_hardware_img {
    background: url('../../assets/img/park-construction/YQ_banner_bg.jpg') 0 0 no-repeat;
    background-size: 100% 100%;
    @media screen and (max-width: 768px) {
      background-size: cover ;
      background-position: 45% 100%;
    }
  }
  .it_hardware_title_wrap {
    width: 100%;
    margin-top: 50px;
    //padding-bottom: 50px;
    @media screen and (max-width: 768px) {
      margin-top: 30px;
      //padding-bottom: 20PX;
    }
  }

  .dingwei-bottom{
    width: 100%;
    height: 400px;
    margin-bottom: 50px;
    background: url('../../assets/img/park-construction/YQ_bg.jpg') 0 0 no-repeat;
    background-size: 100% 100%;
    justify-items: center;
    justify-content: center;
    align-items: center;
    display: flex;
    @media screen and (max-width: 768px) {
      height: 260PX;
      background-size: cover ;
      background-position: 70% 100%;
    }
    .it_hardware_desc{
      padding-top: 20px;
      font-size:20px ;
      color: #fff;
      @media screen and (max-width: 768px) {
        width: 80%;
        text-align: center;
        font-size: 0.8rem;
        line-height: 1.2rem;
      }
    }
    .it_hardware_title{
      font-size:34px ;
      color: #fff;
      @media screen and (max-width: 768px) {
        width: 80%;
        text-align: center;
        font-size: 1.1rem;
        line-height: 1.5rem;
        padding-top: 10px;
      }
    }
  }
  .dingwei-bg{
    background: url('../../assets/img/solution/dingwei-bg.jpg') 0 0 no-repeat;
    background-size: 100% 100%;
    border-radius: 4px;
    padding: 60px 40px 60px 40px !important;

    img{
      margin-bottom: 10px;
      width: 100% !important;
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
    }
    .it_hardware_item {
      width: calc(100% / 4 - 20px) !important; /* 减去间距 */
      margin: 8px 10px !important; /* 可根据需要调整 */
      padding-right: 0 !important;
      background-color: #fff;
      border-radius: 6px;
      display: unset !important;
      border: 1px solid rgba(224, 236, 255, 1);
      box-shadow: 6px 6px 16px 2px rgba(12, 28, 56, 0.05);
    }
    .title{
      font-size: 20px !important;
      padding: 15px 15px 30px 15px;
      text-align: center;
      .content{
        text-align: left;
        font-size: 13px !important;
      }
    }

  }
  .bottom{
    width: 60%;
    margin: auto;
    text-align: center;
    margin-top: -80px;
    color: rgba(37, 53, 84, 0.5);
    font-size: 14px;
  }
  .it_hardware_box {
    margin: auto;
    width: 70%;
    display: flex;
    justify-content: center;
    margin-top: 40px;
    margin-bottom: 10px;
    @media screen and (max-width: 768px) {
      width: 95%;
      justify-content: space-around;
      flex-wrap: wrap;
      margin-top: 10PX;
      margin-bottom: 30PX;
    }
    .bg{
      width: 100%;
      border-radius: 4px;
    }
    .it_hardware_item {
      width: calc(100% / 4 - 12px); /* 减去间距 */
      margin: 8px 6px; /* 可根据需要调整 */
      padding-right: 40px;
      display: flex;
      @media screen and (max-width: 768px) {
        width: 100%;
        margin-left: 0;
        margin-top: 10PX;
        box-shadow: 2px 2px 5px 2px rgba(12, 28, 56, 0.05);
        border-radius: 4px;
        background: rgba(255, 255, 255, 1);
        padding: 20px 10px;
        border: 1px solid rgba(224, 236, 255, 1);

      }
      .title{
        width: 100%;
        font-size: 24px;
        color: rgba(37, 53, 84, 1);
        @media screen and (max-width: 768px) {
          font-size: 0.9rem;
          line-height: 1.5rem;
          font-weight: bold;
        }
        img{
          margin-bottom: 10px;
          width: 60px;
          @media screen and (max-width: 768px) {
            width:40PX;
            float: left;
            margin-right: 15PX;
          }
        }
        .content{
          margin-top: 10px;
          font-size: 14px;
          line-height: 24px;
          color: rgba(37, 53, 84, 0.6);
          @media screen and (max-width: 768px) {
            font-size: 0.7rem;
            line-height: 1.2rem;
            margin-left: 55PX;
            font-weight: normal;
          }
        }
        .second-content{
          margin-top: 0;
        }
      }
    }
  }
  p {
    text-align: center;
    color: #3b3b3b;
    font-weight: bold;
    font-size: 20px;
    line-height: 100px;
    @media screen and (max-width: 768px) {
      font-size: 0.9rem;
      padding: 15px 0;
    }
  }
  .service-card {
    width: 100%;
    margin: 50px auto;
    background-color: #fff;
    @media screen and (max-width: 768px) {
      margin: 18PX auto 0 auto;
      padding-bottom: 5PX;
    }
  }
  .it_hardware_card {

    width: 70%;
    margin: 50px auto;
    @media screen and (max-width: 768px) {
      width: 95%;
      margin: 20PX auto;
    }

    .title-div{
      img{
        float: left;
        height: 30px;
        width: 1px;
        margin-top: 5px;
      }
      .title{
        float: left;
        font-size: 32px;
        line-height: 40px;
        font-weight: bold;
        color: #05102F;
        padding-right: 15px;
      }
      .desc{
        float: left;
        font-size: 22px;
        line-height: 40px;
        color: #808080;
        padding-left: 15px;
      }
    }
    .item-content{
      width: 100%;
      display: flex;
      justify-content: center;
      padding: 50px 0;
      .sub-item-yzs{
        border-radius: 4px;
        background: #FFFFFF;
        border: 1px solid #E0ECFF;
        padding: 10px;
        box-shadow: 6px 6px 16px 2px rgba(12, 28, 56, 0.1);
        width: calc(100% / 5 - 10px); /* 减去间距 */
        margin-right: 20px;
        .down-card{
          width: 100%;
          padding: 0 8px 0px 8px;
          color: #808080;
          line-height: 26px;
          font-size: 13px;
        }
        .up-card{
          display: flex;
          line-height: 60px;
          font-size: 22px;
          color: #16181A;
          font-weight: bold;
          img{
            width: 28%;
            margin-right: 5px;
          }
        }
        &:hover{
          box-shadow: 6px 6px 16px 2px rgba(12, 28, 56, 0.2);
          .up-card{
            color: #0052D9;
          }
        }
      }

    }
  }
  .advantage_out_wrap {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .carousel_pro {
    width: 60%;
    margin: 60px auto;
    .carousel_pro_item {
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }

}
.basic-area{
  margin: auto;width: 70%;
  padding: 0 14px 30px 14px;

  .title{
    border-radius: 8px;color: #fff;
    background: #3393FD;
    line-height: 40px;
    text-align: center;
  }
  .content{
    border-radius: 8px;
    background: linear-gradient(180deg, #F6F8FF 0%, #D9E6FA 100%);
    border: 2px dashed #a3c4fe;
    width: 100%;
    margin-top: 10px;
    padding: 15px 8px;
    display: flex;
    .content-item{
      padding: 20px;
      text-align: center;
      margin: 0 1%;
      //float: left;
      width: 9%;
      border: 2px dashed #a3c4fe;
      background-color: #FBFDFF;
      border-radius: 8px;
      align-content: center;
      color: #05102F;
    }

  }
}
.it_hardware_core_scene{
  background-color: #F5F7FA;
  width: 70%;
  margin: 30px auto;
  padding: 30px 50px 20px 50px;
  height: 350px;
  border-radius: 4px;
  background: linear-gradient(180deg, rgba(2, 99, 255, 1) 41.2%, rgba(131, 181, 254, 1) 100%);
  .it_hardware_core_scene_title{
    align-content: center;
    color: #fff;
    letter-spacing: 2px;
    padding-bottom: 20px;
    .sub1{
      font-size: 32px;
      margin-right: 10px;
      font-weight: bold;
      line-height: 40px;
      float: left;
    }
    img{
      float: left;
      height: 30px;
      margin-top: 5px;
      width: 1px;
    }
    .sub2{
      margin-left: 10px;
      font-size: 20px;
      line-height: 40px;
      float: left;
    }
  }
  .item-bg{
    float: left;
    width: 24%;
    img{
      width: 90%;
    }
  }
  .item{
    float: left;
    width: 16%;
    padding: 0 20px;
    margin-left: 3%;
    text-align: center;
    border-radius: 4px;
    background: linear-gradient(0deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 39.8%, rgba(255, 255, 255, 0.8) 64.35%, rgba(255, 255, 255, 0.6) 100%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 230px;
    font-size: 12px;
    color: #8491AB;
    .bg{
      width: 46%;
    }
    .hx{
      margin: 10px 0;
      width: 100%;
    }
    .btn-area{
      width: 100%;
    }
    .left-div{
      flex: 1;
      width: 48%;
      background: #EBEFF5;
      line-height: 30px;
      border-radius: 4px;
      float: left;
      font-size: 13px;
      margin-right: 2%;
    }
    .right-div{
      width: 48%;
      flex: 1;
      background: #EBEFF5;
      line-height: 30px;
      border-radius: 4px;
      float: left;
      font-size: 13px;
    }
    span{
      font-size: 20px;
      line-height: 40px;
      font-weight: bold;
      color: #253554;
    }
  }

}
.tab-area{
  margin: auto;
  width: 100%;
  .tabs{
    margin: 0 15%;
    margin-top: -50px;
  }
  .tab-area-bg{
    background: #FFFFFF;
    height: 60px;
    box-shadow: 0 4px 12px rgba(12, 28, 56, 0.2);
  }
}
.tab-area-fixed{
  position: fixed;
  top: 70px;
  z-index: 999;
}
::v-deep(.el-tabs__nav-wrap::after){
  background-color: #fff !important;
}
::v-deep(.el-tabs__item ){
  margin-bottom: 10px;
}
::v-deep(.el-tabs__item.is-active ){
  color: #0052D9  !important;
}
::v-deep(.el-tabs__active-bar){
  background-color: #0052D9  !important;
  height: 3px;
}
.shenru-btn {
  width: 180px;
  height: 40px;
  background: #0052D9;
  color: #fff;
  bottom: 15%;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.5s;
  margin: 30px auto 10px auto;
  &:hover {
    color: #fff;
    font-weight: bold;
    background: #24b1ff;
  }
  @media screen and (max-width: 768px) {
    width: 80px;
    height: 30px;
    font-size: 14px;
  }
}
.gaizao{
  width: 100%;
  margin-bottom: 20px;
}
.padding80{
  padding-top: 80px
}
.card_wrap {
  width: 70%;
  flex-wrap: wrap;
  margin: 0px auto;
  justify-content: space-between;
  padding-bottom: 20px;
  @media screen and (max-width: 768px) {
    width: 95%;
    padding-bottom: 30PX;
  }
  .brain_item {
    transition: background-color 1s;
    padding: 20px 5px;
    //background: #fff;
    border-radius: 4px;
    border: 2px solid #fff;
    background: linear-gradient(180deg, #F3F5F8 0%, #FFFFFF 100%);
    box-shadow: 0 0.5rem 1.5rem 0.5rem rgb(12 28 56 / 10%);
    margin-top: 40px;
    position: relative;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      border-radius: 4PX;
      display: flex;
      flex-wrap: wrap;
      justify-content: start;
      margin-top: 10PX;
      padding: 15PX 5PX;
      background: linear-gradient(180deg, rgba(237, 241, 252, 1) 0%, rgba(255, 255, 255, 1) 100%);
    }
    .img_item {
      margin-top: 10px;
      width: 90% ;
      @media screen and (max-width: 768px) {
        width: 70% ;
      }
    }
    &:hover{
      box-shadow: 0 0.5rem 1.5rem 0.5rem rgb(12 28 56 / 18%);
    }
    .item_bg {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(180deg, #F3F5F8 0%, #FFFFFF 100%);
      //box-shadow: 0 0.5rem 1.5rem 0.5rem rgb(12 28 56 / 12%);
      opacity: 0;
      transition: all 0.5s;
      border-radius: 4px;
      z-index: 1;
      border: 1px solid #fff;
    }
    &:hover .item_bg{
      opacity: 1;
    }
    &:hover .item_title {
      color: #0052D9;
    }
    //&:hover .item_desc {
    //  color: #0052D9;
    //}
    .item_title {
      transition: all 0.5s;
      font-size: 18px;
      font-weight: bold;
      color: #203040;
      text-align: left;
      padding: 10px 0 10px 0;
      z-index: 2;
      position: inherit;
      @media screen and (max-width: 768px) {
        font-size: 1rem;
      }
    }
    .item_desc {
      width: 90%;
      transition: all 0.5s;
      color: #666;
      text-align: left;
      line-height: 24px;
      z-index: 2;
      position: inherit;
      font-size: 13px;
      min-height: 30px;
      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        line-height: 1.2rem;
      }
      i{
        padding-right: 5px;
        color: #19B21E;
        font-weight: bold
      }
    }
    .item_navigate {
      width: 100PX;
      height: 30PX;
      padding: 0 10px;
      background: #ffa400;
      color: #fff;
      border-radius: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      margin-top: 40px;
      cursor: pointer;
      z-index: 2;
      position: inherit;
      @media screen and (max-width: 768px) {
        margin-bottom: 10PX;
        font-size: 14px;
      }
    }
  }
}
.flow-title{
  padding-bottom: 0 !important;
}
.con{
  padding-left: 18px;
}
.center-area{
  background-color: #fff;
  width: 70%;
  margin: auto;
  @media screen and (max-width: 768px) {
    width: 100%;
    padding: 2.5%;
    margin-top: 10PX;
  }

  .tab-content{
    margin-bottom: 120px;
    //@media screen and (max-width: 768px) {
    //  width: 95%;
    //  margin-bottom: 50PX;
    //}
    .el-radio-group {
      width: 80%;
      margin:40px auto 20px auto;
      display: flex;
      justify-content: center;
      @media screen and (max-width: 768px) {
        width: 100%;
      }
    }
    ::v-deep(.el-radio-button:first-child .el-radio-button__inner) {
      border-radius: 0 !important;
    }
    ::v-deep(.el-radio-button:last-child .el-radio-button__inner) {
      border-radius: 0 !important;
    }
    ::v-deep(.el-radio-button__orig-radio:checked+.el-radio-button__inner){
      background-color: #0052D9 !important;
      border: 1px solid #0052D9 !important;
    }
    ::v-deep(.el-radio-button) {
      width: calc(100%/6 - 4px);
      text-align: center;
      @media screen and (max-width: 768px) {
        width: calc(100%/3 - 4px);
      }
    }
    ::v-deep(.el-radio-button__inner) {
      width: 90%;
      margin: auto;
      background-color: #F2F2F2;
      border: 1px solid #F2F2F2;
      -webkit-box-shadow: unset;
      box-shadow: unset;
      padding: 14px;
      @media screen and (max-width: 768px) {
        padding: 7PX;
        font-size: 0.8rem;
      }
    }
    .half-inner{
      width:12.5%;
      float: left;
      ::v-deep(.el-radio-button) {
        width: 100% !important;
        text-align: right;
      }
      .el-radio-group {
        width: 100%;
        //float: left;
      }


    }
    .half-inner-middle{
      width:100%;
      float: left;
      ::v-deep(.el-radio-button) {
        width: calc(100%/2 - 4px) !important;
        text-align: center;
        @media screen and (max-width: 768px) {
          width: 100%;
          padding-top: 2PX;
        }
      }
      .el-radio-group {
        width: 100%;
      }
      ::v-deep(.el-radio-button__orig-radio:checked+.el-radio-button__inner){
        background-color: #fff !important;
        color: #0052d9;
        border: 1px solid #fff !important;
      }

      ::v-deep(.el-radio-button__inner) {
        width: 90%;
        margin: auto;
        background-color: #fff;
        border: 1px solid #fff;
        -webkit-box-shadow: unset;
        box-shadow: unset;
        padding: 14px;
      }
    }
    .half-inner-right{
      width:100%;
      float: left;
      //@media screen and (max-width: 768px) {
      //  width: 100%;
      //}
      ::v-deep(.el-radio-button) {
        width: calc(100%/3 - 6px) !important;
        text-align: center;

        @media screen and (max-width: 768px) {
          width: 100%;
          padding-top: 10PX;
          padding-bottom: 20PX;
        }
      }
      .el-radio-group {
        width: 100%;
      }
      ::v-deep(.el-radio-button__orig-radio:checked+.el-radio-button__inner){
        background-color: #fff !important;
        color: #0052d9;
        border: 1px solid #fff !important;
      }

      ::v-deep(.el-radio-button__inner) {
        width: 90%;
        margin: auto;
        background-color: #fff;
        border: 1px solid #fff;
        -webkit-box-shadow: unset;
        box-shadow: unset;
        padding: 14px;
      }
    }

  }
}
.row-div{
  width: 100%;
  padding-bottom: 30px;
  @media screen and (max-width: 768px) {
    padding-top: 10PX;
  }

}
.hx-desc{
  font-size: 14px;
  color: #808080;
  line-height: 24px;
  text-align: center;
  @media screen and (max-width: 768px) {
    font-size: 0.7rem;

    line-height: 1.2rem;
  }
}
.height1{
  height: 550px;
  @media screen and (max-width: 768px) {
    height: auto;
    margin-bottom: 10PX;
  }
}
.height2{
  height: 660px;
  @media screen and (max-width: 768px) {
    height: auto;
    margin-bottom: 10PX;
  }
}
.height3{
  height: 500px;
  @media screen and (max-width: 768px) {
    height: auto;
    margin-bottom: 10PX;
  }
}
.height4{
  height: 350px;
  @media screen and (max-width: 768px) {
    height: auto;
    margin-bottom: 10PX;
  }
}
.height5{
  height: 480px;
  @media screen and (max-width: 768px) {
    height: auto;
    margin-bottom: 10PX;
  }
}
.height6{
  height: 450px;
  @media screen and (max-width: 768px) {
    height: auto;
    margin-bottom: 10PX;
  }
  img{
    height: 100%;
    //border-radius: 10px;
    @media screen and (max-width: 768px) {
      width: 100%;
      height: 100%;
      border-radius: 6PX;
    }
  }
}
.height7{
  height: 500px;
  @media screen and (max-width: 768px) {
    height: auto;
    margin-bottom: 10PX;
  }
  img{
    width: 60%;
    height: 85%;
    //border-radius: 10px;
    @media screen and (max-width: 768px) {
      height: 100%;
      width: 100%;
      border-radius: 6PX;
    }
  }
}
.hx-text{
  padding: 20px 20px 20px 15px;
  @media screen and (max-width: 768px) {
    padding: 10PX 10PX 10PX 10PX;
  }
  .title-sub1{
    color: #05102F;
    font-size: 26px;
    font-weight: bold;
    @media screen and (max-width: 768px) {
      font-size: 1.2rem;
    }
  }
  .title-sub2{
    color: #808080;
    font-size: 16px;
    margin-top: 15px;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      line-height: 1.2rem;
    }
  }
}
.hx-btn{
  background-color: #0052D9;
  margin-top: 20px;
  font-size: 14px;
  @media screen and (max-width: 768px) {
    font-size: 0.7rem;
    width: 180PX;
    line-height: 1.8rem;
    border-radius: 50PX;
    margin-top: 20PX;
  }
}
.hx-content-height1{
  @media screen and (max-width: 768px) {
    height: auto !important;
  }
}
.hx-content-height2{
  @media screen and (max-width: 768px) {
    height: auto;
  }
}
.hx-content{
  margin-top: 30px;
  //height: 86px;
  border-left: 5px solid rgb(0, 82, 217,0.6);
  padding-left: 10px;
  @media screen and (max-width: 768px) {
    margin-top: 15PX;
    height: auto;
    border-left: 3PX solid rgb(0, 82, 217,0.6);
    padding-left: 10PX;
  }
  .line{
    display: none;
    float: left;
    height: 100%;
    width: 4px;
    background-color: rgb(0, 82, 217,0.6);
    margin-right: 10px;
    @media screen and (max-width: 768px) {
      height: 90PX;
      width: 2PX;
      margin-right: 10PX;
      display: none;
    }
  }
  &:hover{
    border-color: rgb(0, 82, 217, 1);;
    .line {
      background-color: rgb(0, 82, 217, 1);
    }
    .title {
      color: rgb(0, 82, 217, 1);
      font-weight: bold;
    }
  }
  .title-sy{
    color: #05102F;
    font-size: 20px;
    margin-bottom: 5px;
    @media screen and (max-width: 768px) {
      font-size: 0.85rem;
      line-height: 1.5rem;
    }

  }
  .desc{
    color: rgb(128, 128, 128);
    font-size: 14px;
    padding-bottom: 5px;
    @media screen and (max-width: 768px) {
      font-size: 0.7rem;
      line-height: 1.2rem;
    }
  }
}
.hx-img{
  align-content: center;
  align-items: center;
  text-align: center;
  display: grid;
  @media screen and (max-width: 768px) {
    margin-bottom: 20PX;
  }
  img{
    width: 95%;
    //border-radius: 10px;
    @media screen and (max-width: 768px) {
      width: 100%;
      border-radius: 6PX;
    }
  }
}

.hzhb {
  width: 100%;

  img {
    width: 100%;
  }
;
}
</style>